module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "logo_svg.6deed0d5.svg";